module.exports = __webpack_public_path__ + "static/Time-Of-Day-Clock-d4c8011d0f1cbfbe2882b9f588d3af8c.png";